<script type="ts">
  import { fade } from "svelte/transition";

  export let id;
  export let title;
  export let link;
  export let excerpt;

  const fadeParams = {
    duration: 250
  }


</script>

<a transition:fade={fadeParams} class="dropdown-product" href={link}>
  <div class="dropdown-product__wrapper">
    <span class="dropdown-product__icon">ao</span>
    <h4 class="dropdown-product__title">
      {title.rendered}
    </h4>
    <p class="dropdown-product__excerpt">
      {@html excerpt.rendered}
    </p>
  </div>
</a>
